<div class="checkout-step checkout-delivery-mode">
  <div class="checkout-step-content">
    <span class="label-step">{{ 'checkout.deliveryMode.selectLabel' | translate }}</span>
    <div class="delivery-mode-options">
      <label class="radio-option" [class.selected]="selectedMode === 'CIF'">
        <input type="radio" name="deliveryMode" value="CIF" [checked]="selectedMode === 'CIF'" (change)="onModeChange('CIF')" />
        <span class="radio-option-label"> <strong>CIF</strong> — {{ 'checkout.deliveryMode.cif' | translate }} </span>
      </label>

      <label class="radio-option" [class.selected]="selectedMode === 'FOB'">
        <input type="radio" name="deliveryMode" value="FOB" [checked]="selectedMode === 'FOB'" (change)="onModeChange('FOB')" />
        <span class="radio-option-label"> <strong>FOB</strong> — {{ 'checkout.deliveryMode.fob.label' | translate }} </span>
      </label>
    </div>

    @if (isFob) {
      <div class="fob-vehicle-form" [formGroup]="fobForm">
        <h3 class="fob-form-title">{{ 'checkout.deliveryMode.fob.formTitle' | translate }}</h3>

        <div class="fob-form-grid">
          <!-- Placa do Veículo -->
          <div class="form-group">
            <label class="form-label" for="plate">
              {{ 'checkout.deliveryMode.fob.plate' | translate }} <span class="required">*</span>
            </label>
            <input
              id="plate"
              type="text"
              class="form-control"
              [class.is-invalid]="isFieldInvalid('plate')"
              formControlName="plate"
              mask="SSS-0000||SSS0S00"
              [validation]="false"
              style="text-transform: uppercase"
              placeholder="ABC-1234"
              maxlength="8"
            />
            @if (isFieldInvalid('plate')) {
              <span class="error-message">{{ 'checkout.deliveryMode.fob.plateError' | translate }}</span>
            }
          </div>

          <!-- Tamanho do Veículo -->
          <div class="form-group">
            <label class="form-label" for="vehicleSize">
              {{ 'checkout.deliveryMode.fob.vehicleSize' | translate }} <span class="required">*</span>
            </label>
            <select
              id="vehicleSize"
              class="form-control form-select"
              [class.is-invalid]="isFieldInvalid('vehicleSize')"
              formControlName="vehicleSize"
            >
              <option value="">{{ 'checkout.deliveryMode.fob.vehicleSizePlaceholder' | translate }}</option>
              @for (size of vehicleSizes; track size) {
                <option [value]="size">{{ size }}</option>
              }
            </select>
            @if (isFieldInvalid('vehicleSize')) {
              <span class="error-message">{{ 'checkout.deliveryMode.fob.vehicleSizeError' | translate }}</span>
            }
          </div>

          <!-- Marca -->
          <div class="form-group">
            <label class="form-label" for="brand">
              {{ 'checkout.deliveryMode.fob.brand' | translate }} <span class="required">*</span>
            </label>
            <input
              id="brand"
              type="text"
              class="form-control"
              [class.is-invalid]="isFieldInvalid('brand')"
              formControlName="brand"
              placeholder="{{ 'checkout.deliveryMode.fob.brandPlaceholder' | translate }}"
            />
            @if (isFieldInvalid('brand')) {
              <span class="error-message">{{ 'checkout.deliveryMode.fob.brandError' | translate }}</span>
            }
          </div>

          <!-- Modelo -->
          <div class="form-group">
            <label class="form-label" for="model">
              {{ 'checkout.deliveryMode.fob.model' | translate }} <span class="required">*</span>
            </label>
            <input
              id="model"
              type="text"
              class="form-control"
              [class.is-invalid]="isFieldInvalid('model')"
              formControlName="model"
              placeholder="{{ 'checkout.deliveryMode.fob.modelPlaceholder' | translate }}"
            />
            @if (isFieldInvalid('model')) {
              <span class="error-message">{{ 'checkout.deliveryMode.fob.modelError' | translate }}</span>
            }
          </div>

          <!-- Nome do Motorista -->
          <div class="form-group form-group--full">
            <label class="form-label" for="driverName">
              {{ 'checkout.deliveryMode.fob.driverName' | translate }} <span class="required">*</span>
            </label>
            <input
              id="driverName"
              type="text"
              class="form-control"
              [class.is-invalid]="isFieldInvalid('driverName')"
              formControlName="driverName"
              placeholder="{{ 'checkout.deliveryMode.fob.driverNamePlaceholder' | translate }}"
            />
            @if (isFieldInvalid('driverName')) {
              <span class="error-message">{{ 'checkout.deliveryMode.fob.driverNameError' | translate }}</span>
            }
          </div>

          <!-- Celular -->
          <div class="form-group">
            <label class="form-label" for="phone">
              {{ 'checkout.deliveryMode.fob.phone' | translate }} <span class="required">*</span>
            </label>
            <input
              id="phone"
              type="text"
              class="form-control"
              [class.is-invalid]="isFieldInvalid('phone')"
              formControlName="phone"
              mask="(00) 00000-0000"
              placeholder="(00) 00000-0000"
            />
            @if (isFieldInvalid('phone')) {
              <span class="error-message">{{ 'checkout.deliveryMode.fob.phoneError' | translate }}</span>
            }
          </div>

          <!-- Data Sugerida para Retirada -->
          <div class="form-group">
            <label class="form-label" for="pickupDate">
              {{ 'checkout.deliveryMode.fob.pickupDate' | translate }} <span class="required">*</span>
            </label>
            <input
              id="pickupDate"
              type="date"
              class="form-control"
              [class.is-invalid]="isFieldInvalid('pickupDate')"
              formControlName="pickupDate"
              [min]="today"
            />
            @if (isFieldInvalid('pickupDate')) {
              <span class="error-message">{{ 'checkout.deliveryMode.fob.pickupDateError' | translate }}</span>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
